/**
 * Evita que el formulario se envie al pulsar Enter
 */
document
  .getElementById("register-form")
  .addEventListener("keydown", function (event) {
    if (event.key === "Enter") {
      event.preventDefault();
    }
  });

function searchShop() {
  let searchUrl = $("#shop-finder").data("url");
  let shopCode = $("#shop-code").val();

  $.ajax({
    url: searchUrl,
    method: "GET",
    data: {
      id: productId,
    },
    success: function (response) {
      $("#product-data-modal .modal-content").html(response);
      $("#product-data-modal").modal();
    },
  });
}

/**
 * Escribir únicamente 6 caracteres
 */
document.getElementById("shop-code").addEventListener("input", function () {
  const maxLength = 6;
  const inputValue = this.value;

  if (inputValue.length > maxLength) {
    this.value = inputValue.slice(0, maxLength);
  }
});

/**
 * Habilitar el botón de validar únicamente si hay 6 caracteres en el input
 */
$("#shop-code").on("keyup", function () {
  let shopCode = $("#shop-code").val();

  if (shopCode.length >= 6) {
    $("#shop-finder-submit").prop("disabled", false);
  } else {
    $("#shop-finder-submit").prop("disabled", true);
  }
});

function searchShop() {
  let url = $("#shop-finder").data("url");
  let code = $("#shop-code").val().toUpperCase();

  $.ajax({
    url: url,
    method: "GET",
    headers: {
      "X-Request-Type": "WEB-APP",
    },
    data: {
      code: code,
    },
    success: function (response) {
      $("#shop-finder").addClass("d-none");
      $("#find-results").html(response);
    },
  });
}

$("#shop-finder-submit").on("click", function () {
  searchShop();
});

function retrySearch() {
  $("#shop-finder").addClass("blur-in");
  $("#shop-finder").removeClass("d-none");
  $("#find-results").html("");
}

function confirmShop() {
  let confirmBox = $("#confirm-shop");
  confirmBox.remove();
  $("#customer-data").addClass("blur-in");
  $("#customer-data").removeClass("d-none");
}

/**
 * Cambiar el formulario de registro en función de lo que sea el cliente.
 */
function loadTypeForm() {
  $.ajax({
    url: $("#form-body").data("url"),
    method: "GET",
    headers: {
      "X-Request-Type": "WEB-APP",
    },
    data: {
      type: $("#type").val(),
    },
    success: function (response) {
      $("#form-body").html(response);
      $("#facility-data").removeClass("d-none");
      $("#send-data").removeClass("d-none");
      $("#my-password").removeClass("d-none");
      $('select[name="addressCountry"]').select2({
        theme: "bootstrap4",
      });
    },
  });
}

$("#type").on("change", () => loadTypeForm());

function facilityType() {
  if ($("#facility-type").val() == "pool") {
    $(".overflow-pool").slideDown();
    checkOverflow();
  } else {
    $(".overflow-pool").slideUp();
    $("#pool_overflow_tank").prop("required", false);
  }
}
facilityType();

$("#facility-type").on("change", () => facilityType());

/**
 * Comprobar el tanque de compensación
 */
function checkOverflow() {
  if ($("#pool_overflow_si").is(":checked")) {
    $(".overflow-tank").slideDown();
    $("#pool_overflow_tank").prop("required", true);
  } else {
    $(".overflow-tank").slideUp();
    $("#pool_overflow_tank").prop("required", false);
  }
}

$(() => checkOverflow());

$("#pool_overflow_si").on("change", () => checkOverflow());
$("#pool_overflow_no").on("change", () => checkOverflow());
